import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../auth/hooks/useAuth";
import { deleteUserQuestion } from "../../../api/userQuestion";

export const useDeleteUserQuestion = () => {
    const { csrfToken } = useAuth();

    const mutation = useMutation({
        mutationFn: async (id: string) => {
            await deleteUserQuestion(id, csrfToken);
        },
    });

    return { deleteUserQuestion: mutation };
};
